import { $ } from '../utils/Utils';
import endPoint from '../utils/end-points';

require('es6-promise').polyfill();
const axios = require('axios');

const logout = (() => {
  const config = {
    triggers: [...$('.js-logout')],
  };

  const handleLogout = () => {
    axios.post(`${endPoint.logout}`)
      .then(response => {
        if (response.status === 200) {
          window.location.reload()
        }
      }).catch(error => {
        console.log(error);
      });
  };

  const build = () => {
    axios.post(`${endPoint.isloggedin}`).then(response => {
      if (response.data.successful)
        handleLogout();
    }).catch(error => {
      console.log(error);
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };
  return {
    init,
  };
})();
export default logout.init();
